<template>
  <!-- Compact FAB Menu - Same style as SalesDashboard -->
  <div class="fixed bottom-6 right-6 z-50">
    <!-- Action Menu -->
    <Transition
      enter-active-class="transition duration-150 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0">
      <div v-if="showMenu" class="mb-2 bg-white dark:bg-dark-800 rounded-xl shadow-lg border border-gray-200 dark:border-dark-700 p-2">
        <button v-for="(action, index) in availableActions" :key="index"
          @click="handleAction(action)"
          :disabled="action.disabled"
          class="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-700 transition-colors text-left disabled:opacity-50 disabled:cursor-not-allowed">
          <i class="fas text-gray-600 dark:text-gray-400 w-4 text-center" :class="action.disabled ? 'fa-spinner fa-spin' : action.icon"></i>
          <span class="text-sm font-medium text-gray-900 dark:text-white">{{ action.label }}</span>
        </button>
      </div>
    </Transition>

    <!-- Main FAB -->
    <button @click="showMenu = !showMenu"
      class="w-12 h-12 rounded-full bg-teal-600 hover:bg-teal-700 dark:bg-teal-500 dark:hover:bg-teal-600 shadow-lg hover:shadow-xl flex items-center justify-center text-white transition-all duration-200"
      :class="{ 'rotate-45': showMenu }">
      <i class="fas fa-plus text-lg transition-transform duration-200"></i>
    </button>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  hasPermission: {
    type: Function,
    required: true
  }
});

const emit = defineEmits([
  'create-order',
  'create-client',
  'add-payment',
  'create-expense',
  'create-quotation',
  'generate-report',
  'tools'
]);

const showMenu = ref(false);

// Available actions based on permissions - match SalesDashboard order
const availableActions = computed(() => {
  const actions = [];
  
  if (props.hasPermission('orders.create')) {
    actions.push({ icon: 'fa-shopping-cart', label: 'Order', event: 'create-order' });
  }
  
  // Client creation - check if user has clients.create permission, or just show if they can view clients
  if (props.hasPermission('clients.create') || props.hasPermission('clients.view')) {
    actions.push({ icon: 'fa-user-plus', label: 'Client', event: 'create-client' });
  }
  
  actions.push({ icon: 'fa-money-bill-wave', label: 'Payment', event: 'add-payment' });
  
  if (props.hasPermission('expenses.create')) {
    actions.push({ icon: 'fa-receipt', label: 'Expense', event: 'create-expense' });
  }
  
  actions.push({ icon: 'fa-file-invoice', label: 'Quote', event: 'create-quotation' });
  actions.push({ icon: 'fa-chart-bar', label: 'Report', event: 'generate-report' });
  actions.push({ icon: 'fa-tools', label: 'Tools', event: 'tools' });
  
  return actions;
});

const handleAction = (action) => {
  emit(action.event);
  showMenu.value = false;
};
</script>

<style scoped>
/* Glass effects removed for performance */
</style> 